import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronUpBold';
/** Renders an SVG icon. */
const SvgChevronUpBold = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.586 21.414a2 2 0 0 0 2.828 0L16 12.828l8.586 8.586a2 2 0 1 0 2.828-2.828l-10-10a2 2 0 0 0-2.828 0l-10 10a2 2 0 0 0 0 2.828"
      />
    </svg>
  );
};
SvgChevronUpBold.displayName = displayName;
export default SvgChevronUpBold;
